import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function usePoll(path, interval = 60000) {
    const [state, setState] = useState({ data: null, error: null, loading: true });

    useEffect(() => {
        let alive = true;
        let timer;
        const load = async () => {
            try {
                const res = await fetch(`${API}/api${path}`);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (alive) setState({ data, error: data.error || null, loading: false });
            } catch (e) {
                if (alive) setState((s) => ({ ...s, error: e.message, loading: false }));
            }
            if (alive) timer = setTimeout(load, interval);
        };
        load();
        return () => {
            alive = false;
            clearTimeout(timer);
        };
    }, [path, interval]);

    return state;
}

export const fmtUsd = (n, opts = {}) => {
    if (n == null || Number.isNaN(n)) return "—";
    if (n > 0 && n < 0.01) return `$${n.toLocaleString("en-US", { minimumSignificantDigits: 3, maximumSignificantDigits: 4 })}`;
    return `$${n.toLocaleString("en-US", { maximumFractionDigits: 2, ...opts })}`;
};

export const fmtNum = (n, digits = 0) =>
    n == null || Number.isNaN(n) ? "—" : n.toLocaleString("en-US", { maximumFractionDigits: digits });

export const fmtCompact = (n) =>
    n == null || Number.isNaN(n)
        ? "—"
        : n.toLocaleString("en-US", { notation: "compact", maximumFractionDigits: 2 });

export const timeAgo = (iso) => {
    if (!iso) return "";
    const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    return `${Math.floor(s / 3600)}h ago`;
};
